import { __rest } from "tslib";
import React from 'react';
import { BtwHeading } from './BtwHeading';
import { BtwText } from './BtwText';
import { BtwToggle } from './BtwToggle';
import { BtwTooltip } from './BtwTooltip';
import { Stack } from './Stack';
function BtwSettingsItem(props) {
    const { heading, description, disabled, disabledTooltipText } = props, rest = __rest(props, ["heading", "description", "disabled", "disabledTooltipText"]);
    return (React.createElement(Stack, { direction: "row", justify: "between", align: "center" },
        React.createElement(Stack, { gap: "1.5", align: "start" },
            React.createElement(BtwHeading, { weight: "medium", size: "sm" }, heading),
            description && (React.createElement(BtwText, { className: "text-[0.8125rem] tracking-normal" }, description))),
        React.createElement(BtwTooltip, { content: disabled ? disabledTooltipText : undefined },
            React.createElement("div", null,
                React.createElement(BtwToggle, Object.assign({ disabled: disabled }, rest))))));
}
export { BtwSettingsItem };
